// extracted by mini-css-extract-plugin
module.exports = {"row":"staffRow_row__3Ozcc","left_sec":"staffRow_left_sec__2tP-y","right_sec":"staffRow_right_sec__19zMn","fixed":"staffRow_fixed__1sK3K"};